<template>
<popup title="Create discount" @close="close" class="create-discount-popup" >
	<template v-slot:content>
		<div class="layout-column margin-t-15" style="position: relative">
			<div>
				<input-field label="Name" placeholder="eg. CODE20OFF..." required v-model="discount.name" />
			</div>
			<div class="layout-column margin-t-15">
				<label class="label">Type</label>
				<div class="layout-row">
					<select-button no-icon label="Percentage" value="percentage" v-model.number="discount.type" class="margin-r-15"  />
					<select-button no-icon label="Fixed" value="fixed" v-model.number="discount.type"  />
				</div>
			</div>
			<div class="layout-column margin-t-25">
<!--				<label class="label">Value</label>-->
				<div class="" style="width: 400px">
					<input-field v-if="discount.type==='percentage'" label="Discount percentage" type="number" :min="0" :max="100"
					             required v-model.number="discount.value" append="%" />

					<input-field v-else label="Discount value" type="number" :min="0"
					             :info="valueInfo"
					             required v-model.number="discount.value" :prepend="currency" >
					</input-field>
				</div>
			</div>

			<expandable-area title="Settings" tag="(optional)" name="create_discount.settings" class="margin-t-25">
				<date-picker date-label="Start date" :min-date="minStartDate"
				             time-label="Start time" v-model="discount.start_time" />

				<v-switch label="Has end date?" class="margin-t-25"
				          :value="hasEndDate" v-model="hasEndDate" @change="hasEndDateChanged($event)" />
				<date-picker v-if="hasEndDate" :min-date="minEndDate"
				             date-label="End date" time-label="End time" v-model="discount.end_time" />
			</expandable-area>

		</div>
	</template>
	<template v-slot:actions>
		<v-button label="Create" @click="create" :loading="saving" :disabled="!discount.value || !discount.name" />
		<v-button label="Cancel" @click="close" border />
	</template>
</popup>
</template>

<script>
import Popup from "@/components/base/popup";
import VButton from "@/components/base/v-button";
import InputField from "@/components/base/input-field";
import VOptionSwitch from "@/components/base/v-option-switch";
import SelectButton from "@/components/base/select_button";
import {mapGetters} from "vuex";
import {getSymbol} from "@/helpers/currencies";
import API from '@/api'
import moment from "moment";
import ExpandableArea from "@/components/base/expandable-area";
import RangePicker from "@/components/base/range-picker";
import DatePicker from "@/components/base/date-picker";
import VSwitch from "@/components/base/v-switch";

export default {
	name: "create_discount", components: {
		VSwitch,
		DatePicker,
		RangePicker,
		ExpandableArea, SelectButton, VOptionSwitch, InputField, VButton, Popup},
	mixins:[API],
	data(){
		return {
			saving: false,
			hasEndDate: false,
			discount: {
				name:'',
				is_active:true,
				type:'percentage',
				value:0,
				start_time: moment(),
				end_time: null,
				max_uses: -1,
			},
		}
	},
	computed:{
		...mapGetters(['']),
		valueInfo(){
			return `The currency will be changed to the one of the funnel
								if it's different from <b>${this.currency}</b>. The discount value will not be converted.`
		},
		currency(){
			return getSymbol(this.$store.state.userInfo.default_currency_code)
		},
		minStartDate() {
			return moment()
		},
		minEndDate() {
			return this.discount.start_time
		},
	},
	methods:{
		hasEndDateChanged(b) {
			if (b) {
				this.discount.end_time = moment(this.discount.start_time).add(30, 'day')
			}
			else
				this.discount.end_time = null
		},
		close(){
			this.$emit('close')
		},
		async create() {
			try {
				this.saving = true;
				this.discount.start_time = moment().utc()
				let r = await this.api.discounts.create(this.discount)
				// console.log(r)
				this.$emit('done', r)
				this.close()
			} catch (e) {
				this.$error(e)
			} finally {
				this.saving = false;
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.create-discount-popup {

}
</style>
